<div class="admin-container">
  <div class="card border-0 p-3">
    <app-grid-table
      [datasource]="projectsDataSource"
      [rowModelType]="'infinite'"
      [columns]="columns"
      [title]="'admin.sideNav.projects.pendingProjectIdeas' | translate"
      detailsBaseRoute="/admin/project-ideas"
      [loading]="isLoading()"
      (searchChange)="searchValue.set($event)"
    />
  </div>
</div>
